import { render, staticRenderFns } from "./ElevateEvents.vue?vue&type=template&id=1050d756&scoped=true"
import script from "./ElevateEvents.vue?vue&type=script&lang=js"
export * from "./ElevateEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1050d756",
  null
  
)

export default component.exports